// extracted by mini-css-extract-plugin
export default {"link":"u9k3ts","clickable":"WQ4fSJ","svgRoot":"aizuI7","nonScalingStroke":"TcoJIb","hasShadow":"elfY4_","hasStroke":"R8rhQA"};